<template>
  <div>
    <center>
      <h1>Watchlist Settings</h1>
      <p>Manage your Watchlist Settings</p>
    </center>
    <hr>
    <div v-for="item in watchlistItems" v-bind:key="item.ID">
      <router-link style="text-decoration: none; color: inherit;" :to="{path: 'watchlist-edit', query: {id: item.ID}}">
          <h2 class=watchlistItems>{{ item.item }}</h2>
      </router-link>
      <hr>
    </div>
    <router-link style="text-decoration: none; color: inherit;" :to="{path: 'new-watchlist'}">
      <v-btn fab dark large color="primary" fixed right bottom>
          <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </router-link>
      <div v-if="showNullMsg" class="departmentAddMsg">
        <center>
        <h2>You do not have any departments on your watchlist</h2>
        <br>
          <v-btn id="premiumButton" :to="{path: 'new-watchlist'}" color="success">Add Department</v-btn>
        </center>
      </div>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// import { set } from 'vue/types/umd';
export default {
  data: () => ({
    watchlistItems: [],
    showNullMsg: false,
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    }
  }),
  name: 'App',

  components: {
  },

  created(){
    if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
    window.scrollTo(0,0);
    this.getWatchlistSettings();
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async getWatchlistSettings(){
      const response = await fetch(localStorage.apiURL + "/app/watchlist/settings", {
        method: "GET",
        headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID},
      });

      if (!response.ok){
        this.error("api returned " + response.status);
        return
      }

      let data = await response.json();

      if (!data.success){
        this.error(data.msg);
        return
      }

      this.watchlistItems = data["items"];

      if (this.watchlistItems.length == 0){
        this.showNullMsg = true;
      }
    }
  },
};
</script>

<style scoped>
.watchlistItems{
  margin-left: 15px;
  margin-right: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.watchlistItems h2{
  margin-left: 10px;
}
p{
  margin: 0;
}
.watchlistItems:hover{
  background-color: rgb(209, 209, 209);
}
  .departmentAddMsg{
    margin-top: 200px;
  }
</style>
